import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { NextcloudFile } from 'src/app/classes';
import { NextcloudPathInfo } from '../../../classes';
import { FileService } from '../../../services/file.service';
import { FileViewModes, SelectFileViewDialogComponent } from '../select-file-view-dialog/select-file-view-dialog.component';

@Component({
  selector: 'app-select-file-dialog',
  templateUrl: './select-file-dialog.component.html',
  styleUrls: ['./select-file-dialog.component.css']
})
export class SelectFileDialogComponent implements OnInit {

  private _currentLocation = new BehaviorSubject('/');
  set currentLocation(location: string) {
    this._currentLocation.next(location);
  }
  pathInfo$: Observable<NextcloudPathInfo> = this._currentLocation.pipe(distinctUntilChanged(), switchMap((location) => this._fileService.getRelativePath(location)), shareReplay(1));
  files$ = this.pathInfo$.pipe(switchMap((info: NextcloudPathInfo) => {
    this._loading.next(true);
    return this._fileService.getFolderByPath(info.convertedPath).pipe(
      tap(files => {
        this.root = files.find(x => x.isItself);
        this._loading.next(false);
      })
    );
  }));
  rootPathArray$ = this.pathInfo$.pipe(map((info) => Array.isArray(info.prettyPathArray) ? info.prettyPathArray : []));
  rootName$ = this.pathInfo$.pipe(map(x => x.rootFolderName? x.rootFolderName: 'Ordner'));

  private _rootSize = new ReplaySubject<string>(1);
  prettyRootSize$ = this._rootSize.pipe(map(x => FileService.prettyFileSize(x)))

  set root(root: NextcloudFile) {
    this._rootSize.next(root ? root.size : null);
  }

  fileFilter: string;
  enableNavigation: boolean = true;

  private _loading = new BehaviorSubject(false);
  loading$ = this._loading.asObservable();

  viewMode: number = FileViewModes.List;
  
  currentSelection: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectFileDialogComponentInputData,
    private _dialogRef: MatDialogRef<SelectFileViewDialogComponent>,
    private _fileService: FileService,
    private _dialog: MatDialog
  ) { }

  changeView() {
    this._dialog.open(SelectFileViewDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false,
      data: this.viewMode
    }).afterClosed().subscribe((result: number) => {
      this.viewMode = result;
      console.log(result);
    });
  }

  close = () => this.files$.subscribe((files) => this._dialogRef.close(files.find(x => x.fileId === this.currentSelection)));

  fileClick(file: NextcloudFile) {
    console.log(file);
  }

  fileDblClick(file: NextcloudFile) {
    this._fileService.getRelativePath(file.href).subscribe((result) => {
      if (result.isFolder) this.currentLocation = file.href;
      else {
        if(typeof this.data.fileSelected === 'function') this.data.fileSelected(file).toPromise();
        else this._fileService.previewFile(file);
      }
    });
  }

  ngOnInit(): void { }

  pathNavigatorChanged = (pathArray: string[]) => this.currentLocation = pathArray.join('/');

  FileViewModes = FileViewModes;
}

export class SelectFileDialogComponentInputData {
  visibleTypes: string[];
  showFolders: boolean;
  showConfirmSelection?: boolean;
  fileSelected: (file: NextcloudFile) => Observable<Object>;
}
